//CookieConsentBanner.tsx - Updated with Language Switcher and Translations

import React from 'react';
import '../../Assets/styles/LandingStyles/CookieBanner/CookieBanner.css';
import { useConsent } from '../../Context/ConsentContext';
import { useLanguage } from '../../Core/Translations/LanguageContext';
import CookieConsentLanding from '../Content/Landing/CookieBanner/CookieConsentLanding';
import { LanguageSelector } from '../../Core/Translations/LanguageSelector'; // Adjust the import path as needed

const CookieConsentBanner: React.FC = () => {
    const {
        showBanner,
        showCustomizeSettings,
        confirmConsent,
        partialConsent,
        toggleConsentSetting
    } = useConsent();

    const { t } = useLanguage();

    if (!showBanner) return null;

    if (!showCustomizeSettings) {
        return <CookieConsentLanding />;
    }

    return (
        <>
            <div className="cookie-banner-overlay" />
            <div className="cookie-banner-consent-banner">
                <div className="cookie-banner-consent-container">
                    <div className="cookie-banner-consent-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className="cookie-banner-consent-title">{t.cookieConsent.title}</h2>
                        <LanguageSelector theme="dark" dropdownDirection='down' />
                    </div>
                    <p className="cookie-banner-consent-description">
                        {t.cookieConsent.description}
                    </p>

                    <div className="cookie-banner-btn-group-top">
                        <button
                            className="cookie-banner-btn cookie-banner-btn-accept-all"
                            onClick={confirmConsent}
                            data-testid="accept-all-cookies-button"
                        >
                            {t.cookieConsent.acceptAll}
                        </button>
                    </div>

                    <div className="cookie-banner-consent-options">
                        <div className="cookie-banner-consent-group">
                            <div className="cookie-banner-consent-group-header">
                                <h3 className="cookie-banner-consent-group-title">{t.cookieConsent.performance.title}</h3>
                            </div>
                            <div className="cookie-banner-consent-item">
                                <div className="cookie-banner-consent-item-info">
                                    <p className="cookie-banner-consent-item-description">
                                        {t.cookieConsent.performance.description}
                                    </p>
                                </div>
                                <label className="cookie-banner-toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={partialConsent.analytics_storage === 'granted'}
                                        onChange={() => toggleConsentSetting('analytics_storage')}
                                    />
                                    <span className="cookie-banner-slider" />
                                </label>
                            </div>
                        </div>

                        <div className="cookie-banner-consent-group">
                            <div className="cookie-banner-consent-group-header" style={{ textAlign: 'left' }}>
                                <h3 className="cookie-banner-consent-group-title">{t.cookieConsent.advertising.title}</h3>
                            </div>
                            <div className="cookie-banner-consent-item">
                                <div className="cookie-banner-consent-item-info">
                                    <p className="cookie-banner-consent-item-description">
                                        {t.cookieConsent.advertising.adStorage}
                                    </p>
                                </div>
                                <label className="cookie-banner-toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={partialConsent.ad_storage === 'granted'}
                                        onChange={() => toggleConsentSetting('ad_storage')}
                                    />
                                    <span className="cookie-banner-slider" />
                                </label>
                            </div>

                            <div className="cookie-banner-consent-item">
                                <div className="cookie-banner-consent-item-info">
                                    <p className="cookie-banner-consent-item-description">
                                        {t.cookieConsent.advertising.adMeasurement}
                                    </p>
                                </div>
                                <label className="cookie-banner-toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={partialConsent.ad_user_data === 'granted'}
                                        onChange={() => toggleConsentSetting('ad_user_data')}
                                    />
                                    <span className="cookie-banner-slider" />
                                </label>
                            </div>

                            <div className="cookie-banner-consent-item">
                                <div className="cookie-banner-consent-item-info">
                                    <p className="cookie-banner-consent-item-description">
                                        {t.cookieConsent.advertising.adPersonalization}
                                    </p>
                                </div>
                                <label className="cookie-banner-toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={partialConsent.ad_personalization === 'granted'}
                                        onChange={() => toggleConsentSetting('ad_personalization')}
                                    />
                                    <span className="cookie-banner-slider" />
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="cookie-banner-btn-group">
                        <button
                            className="cookie-banner-btn cookie-banner-btn-confirm-choices"
                            onClick={confirmConsent}
                            data-testid="confirm-consent-button"
                        >
                            {t.cookieConsent.confirmChoices}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CookieConsentBanner;